/* eslint-disable @typescript-eslint/no-explicit-any */
import { CATALOGUE_MODE, DEFAULT_DEVISE } from "@constants";
import axios from "axios";

import { setPosEditor } from "@store";

import { setPeripheralShopApp } from "@components/Synchronization/store";

import { setDevise } from "@pages/Kiosk/store";

const fetcher = (url: string) =>
    fetch(url)
        .then((response) => response.json())
        .catch((error) => {
            console.log(`Error while fetching data, with message: ${error}`);
            return error;
        });

export async function fetchProjectData(
    url?: string
): Promise<ProjectType | null> {
    // Extract values from localStorage for configuration
    const middlewareApiUrl = JSON.parse(
        localStorage.getItem("middlewareApiUrl") as string
    );
    const selectedShopApp = JSON.parse(
        localStorage.getItem("selectedShopApp") as string
    );

    // Handle different modes based on the environment or config
    if (process.env.REACT_APP_MODE === CATALOGUE_MODE) {
        const franchise_uid = localStorage.getItem("viewADB-franchise_uid");
        const shop_uid = localStorage.getItem("viewADB-shop_uid");
        const urlCatalogue = `${process.env.REACT_APP_SETTINGS_APP_API}/settings/Kiosk_Catalogue?franchiseId=${franchise_uid}&shopId=${shop_uid}`;

        const data = await fetcher(urlCatalogue);
        if (data?.length > 0) {
            return data[0]; // Return the first project found
        }
    }

    // Get shop details from localStorage
    const shopDetails = JSON.parse(
        localStorage.getItem("shopDetail") as string
    );
    if (shopDetails !== null) {
        const settingsUrl = `${middlewareApiUrl}/settings/consomation?franchise_uuid=${shopDetails?.franchise_uid}&shop_uuid=${shopDetails?.shop_uid}`;
        const { data } = await axios.get(settingsUrl);
        localStorage.setItem("serverHostName", data["serverHostName"]);
        const { kiosk } = data;

        if (kiosk.length > 0) {
            setPosEditor(kiosk[0].posEditor);
        }

        const shopApp = kiosk.filter(
            (kiosk: Record<string, string>) =>
                kiosk.appId === selectedShopApp.appId
        );
        setDevise(shopApp[0].devise || DEFAULT_DEVISE);
        setPeripheralShopApp({
            monetics: shopApp[0].monetics || {},
            printers: shopApp[0].printers || {},
            cash_managements: shopApp[0].cash_managements || {},
        });

        // Set fidelity type from shop app if not defined in project
        if (!shopApp[0].project.fidelityType) {
            shopApp[0].project.fidelityType =
                shopApp[0].fidelityType ?? selectedShopApp.fidelityType;
        }

        return shopApp[0].project;
    }

    // Default project fetch if no special handling is needed
    if (url) {
        const data = await fetcher(url);
        return data; // Return the fetched project
    }

    return null; // If no data is found
}
